import React from "react";
import styles from "./index.scss";

const Footer: React.FC<{}> = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.footerContainer}>
                ©{new Date().getFullYear()} Shanghai Daily All right reserved. 上海闪马智能科技有限公司提供技术支持
            </div>
        </div>
    );
};

export default Footer;


